// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YBNnf","title":"styles_title__0LlTA","description":"styles_description__FqddR","content":"styles_content__pnn+m"};